<template>
    <div class="back-to-game-footer">
        <div class="back-to-game-container d-flex justify-content-between align-items-center col-12">
            <div class="col-6 d-none d-sm-block">
                <div class="title">
                    🚨 <Translate translationKey="quests-dashboard.youreOnActiveMission"
                                  fallback="You're on active Mission right now:" /> 🚨
                </div>
                <div class="d-flex align-items-center justify-content-center">
                    <div class="prize">
                        {{ userStore.activeUserRoundData?.quest_round?.quest_mission?.title }}
                    </div>
                </div>
            </div>
            <div class="col-3 d-flex align-items-center justify-content-center">
                <BackToGameFooterTime />
            </div>
            <div class="col-3 back-to-game-footer__button">
                <BaseButton width="auto"
                            :variant="ButtonVariantEnum.SENARY"
                            @click.stop="getUserBackToGame">
                    <Translate translationKey="quests-dashboard.backToMission"
                               fallback="Back to mission" /> ➡
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useAuthStore } from '@/js/store/auth/AuthStore';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { closeCurtains } from '../../../game/animations/closeCurtains';
    import { questsRoutes } from '@/js/constants/questsRoutes';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { ButtonVariantEnum } from '@/js/types/components/ButtonVariantEnum';
    import BackToGameFooterTime from '@/js/quests/dashboard/components/back-to-game-footer/BackToGameFooterTime.vue';

    const authStore = useAuthStore();
    const modalStore = useModalStore();
    const userStore = useUserStore();

    const getUserBackToGame = () => {
        if (authStore.user?.must_verify_email) {
            modalStore.toggleModal(ModalEnum.FORCE_EMAIL_VERIFICATION, true);
        } else {
            closeCurtains(userStore.activeUserRoundData?.quest_round?.content?.url || questsRoutes.MISSION_ROUTE);
        }
    };
</script>

<style scoped lang="scss">
@use "@/sass/missions-partials/z-index" as missionsZIndex;
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/partials/breakpoints" as breakpoints;
@use "@/sass/design-system/fonts" as fonts;
@use "@/sass/design-system/variables" as variables;

.back-to-game-footer {
    position: fixed;
    z-index: missionsZIndex.$dashboard-navigation-wrapper-z-index;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 75px;
    align-items: center;
    justify-content: space-around;
    padding: 16px;
    background-color: variables.$baseBlack;

    .back-to-game-container {
        max-width: breakpoints.$lg-laptop-breakpoint;
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;

        button {
            white-space: nowrap;
        }
    }

    .title {
        color: legacyVariables.$golden-yellow;
        font-family: fonts.$font-quicksand;
        font-size: 19px;
        text-align: center;
        text-transform: uppercase;
    }

    .prize {
        color: variables.$baseWhite;
        font-size: 14px;
        font-weight: 500;
        line-height: 1;
    }

    @media (max-width: 1023px) {
        .title {
            font-size: 16px;
        }

        .prize {
            font-size: 11px;
        }
    }
}
</style>
